import { Component, ElementRef, viewChild } from '@angular/core';

interface MarketCard {
  assetKey: string;
  questionKey: string;
  badgeColor: string;   // asset token badge accent
  yesMultiplier: string;
  noMultiplier: string;
}

@Component({
  selector: 'app-how-to-buy',
  templateUrl: './how-to-buy.component.html',
  styleUrl: './how-to-buy.component.scss',
  standalone: false,
})
export class HowToBuyComponent {
  readonly slider = viewChild.required<ElementRef>('slider');

  readonly markets: MarketCard[] = [
    { assetKey: 'how-to-buy.card1_asset', questionKey: 'how-to-buy.card1_question', badgeColor: '#69DAFF', yesMultiplier: '1.8x', noMultiplier: '2.4x' },
    { assetKey: 'how-to-buy.card2_asset', questionKey: 'how-to-buy.card2_question', badgeColor: '#C3F400', yesMultiplier: '1.5x', noMultiplier: '3.1x' },
    { assetKey: 'how-to-buy.card3_asset', questionKey: 'how-to-buy.card3_question', badgeColor: '#FF51FA', yesMultiplier: '2.2x', noMultiplier: '1.6x' },
  ];

  scrollLeft(): void {
    this.slider().nativeElement.scrollBy({ left: -400, behavior: 'smooth' });
  }

  scrollRight(): void {
    this.slider().nativeElement.scrollBy({ left: 400, behavior: 'smooth' });
  }
}
